export default __webpack_public_path__ + "static/media/image-about-dark.329bbc44.jpg";